import React from "react";
import { Link, useLocation } from "react-router-dom";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";

const Payment = () => {
  const location = useLocation();
  const { orderDetails, message } = location.state || {};

  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="Order Confirmation" />
      <div className="pb-10">
        {message && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
            {message}
          </div>
        )}
        
        {orderDetails ? (
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-2xl font-semibold mb-4">Order Details</h2>
            <div className="space-y-4">
              <div className="border-b pb-4">
                <p className="font-medium">Order ID: <span className="font-normal">{orderDetails.id}</span></p>
                <p className="font-medium">Customer Name: <span className="font-normal">{orderDetails.customerName}</span></p>
                <p className="font-medium">Phone Number: <span className="font-normal">{orderDetails.phoneNumber}</span></p>
                <p className="font-medium">Delivery Area: <span className="font-normal">{orderDetails.deliveryArea}</span></p>
              </div>
              
              <div className="border-b pb-4">
                <h3 className="font-semibold mb-2">Order Items:</h3>
                {orderDetails.orderItems?.map((item, index) => (
                  <div key={index} className="flex justify-between items-center py-2">
                    <span>Product #{item.productId}</span>
                    <span>{item.quantity} x EGP {item.price}</span>
                  </div>
                ))}
              </div>
              
              <div className="space-y-2">
                <p className="flex justify-between">
                  <span className="font-medium">Subtotal:</span>
                  <span>EGP {orderDetails.totalAmount - orderDetails.shippingCharge}</span>
                </p>
                <p className="flex justify-between">
                  <span className="font-medium">Shipping:</span>
                  <span>EGP {orderDetails.shippingCharge}</span>
                </p>
                <p className="flex justify-between text-lg font-semibold">
                  <span>Total:</span>
                  <span>EGP {orderDetails.totalAmount}</span>
                </p>
              </div>
            </div>
          </div>
        ) : (
          <p>No order details available.</p>
        )}
        
        <Link to="/">
          <button className="w-52 h-10 bg-primeColor text-white text-lg mt-4 hover:bg-black duration-300">
            Continue Shopping
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Payment;
